import { asScaled } from '../utils';
/* ------- label布局尺寸 start ------- */
const labelLayout = {
    // 按钮高度
    height: {
        large: 18,
        medium: 16,
        small: 7
    },
    minWidth: {
        large: 32,
        medium: 30,
        small: 28
    },
    paddingHorizontal: {
        large: 8,
        medium: 6,
        small: 4
    }
};
const labelLayoutScaled = asScaled(labelLayout);
export const label = {
    scaled: labelLayoutScaled,
    unscaled: labelLayout
};
